import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Settings from 'donor-elf-web/services/settings';

export default class AllFundsRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare settings: Settings;

  async model() {
    await Promise.all([
      this.abilities.loadForAllFunds(),
      this.settings.loadSettings('-1'),
    ]);
  }

  afterModel() {
    this.navbarSettings.topNavbarComponent = 'top-navbar/all-funds';
  }

  @action
  willTransition(transition: any) {
    let intentName = (transition.intent?.name as string) || '';
    if (!intentName.startsWith('funds.all')) {
      this.navbarSettings.topNavbarComponent = '';
    }
  }
}
